<script>
export default {
  name: 'MaterialSelect',
  props: {
    label: {
      type: String,
    },
    value: {
      default: '',
    },
    name: {
      type: String,
    },
    placeholder: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
    },
    error: {
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    value (newValue) {
      this.inputValue = newValue
    },
  },
  data () {
    return {
      inputValue: this.value,
    }
  },
  methods: {
    onInput (e) {
      this.$emit('input', e)
    },
  },
}
</script>

<template>
  <md-field :class="{ 'md-invalid': error }">
    <label :for="name">{{ label }}</label>
    <md-select v-model="inputValue" :name="name" @input="onInput" style="z-index: 10 !important;">
      <md-option v-for="(item) in options" :key="item.id" :value="item.id">{{ item.title }}</md-option>
    </md-select>
    <span class="md-error">{{ error }}</span>
  </md-field>
</template>

<style lang="scss" scoped>
  .md-menu-content {
    z-index: 12 !important;
  }
  .md-select-menu {
    z-index: 12 !important;
  }
  .md-menu-content.md-select-menu {
    z-index: 12 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Material/MaterialSelect.vue